import { useCallback, useEffect, useState } from 'react';
import Table from 'components/table';
import { ScheduleType, RootState } from 'types';
import { useParams } from 'react-router-dom';
import './schedule-list.scss';
import { useSelector } from 'react-redux';
import api from 'api';
import { SECTION_REPORT_OPTIONS, SECTION_SCHEDULE, timeSince } from '../report-modal';

function ScheduleList(
    {
        className,
        selectCallback,
        setSection,
        deleteSubmit
    } : {
        className: string,
        selectCallback: (data:number) => void,
        setSection: (data: number) => void,
        deleteSubmit: (data:number) => void
    }) {
        
    const params: any = useParams();
    const state = useSelector((state: RootState) => state);
    const [schedules, setSchedules] = useState<ScheduleType[]>([]);
    const [schedulesPage, setSchedulesPage] = useState<ScheduleType[]>([]);
    const [page, setPage] = useState<number>(1);    

    const getSchedules = useCallback(async () => {
        await api.report.getScheduleClient(params.clientId)
        .then((data: ScheduleType[]) => {
            var reportIds = state.reports.map(x => x.Id);
            setSchedules(data.filter(x => reportIds.includes(x.ReportId)));
        })
    }, [params.clientId, state.reports])
    
    useEffect(() => {
        setSchedulesPage(schedules.slice(0, 10*page));
    }, [schedules, page]);
    
    useEffect(() => {
        getSchedules();
    }, [getSchedules]);

    return (
        <div id={'schedule-list'} className={className ? className : 'table-container'}>
            <Table
                headers={{
                    Id: "ID",
                    ReportName: "REPORT NAME",
                    DateLastSent: "LAST SENT",
                    DateNextSend: "DATE NEXT SEND",
                    Frequency: "FREQUENCY",
                    EditReportButton: "",
                    EditScheduleButton: "",
                    DeleteButton: ""
                }}
                items={schedulesPage.map(schedule => ({ 
                    Id: schedule.ReportId,
                    ReportName: state.reports.find(x => x.Id === schedule.ReportId)?.Name,
                    DateLastSent: schedule.DateLastSent,
                    DateNextSend: schedule.DateNextSend,
                    Frequency: state.reportOptions.FrequencyOptions.find(x => x.Id === schedule.FrequencyId)?.Description,
                    EditReportButton: true,
                    EditScheduleButton: true,
                    DeleteButton: true,
                }))}
                customRenderers={{
                    DateLastSent: (item) => (
                        // item.DateLastSent ? new Date(item.DateLastSent).toLocaleString() : "Never"                        
                        item.DateLastSent ? timeSince(new Date(item.DateLastSent)) : "Never" 
                    ),
                    DateNextSend: (item) => (
                        new Date(item.DateNextSend).toLocaleString()
                    ),
                    EditReportButton: (item) => (
                        <i title="Edit Report" className='btn btn-generate far fa-pen' onClick={() => {
                            selectCallback(item.Id); 
                            setSection(SECTION_REPORT_OPTIONS);}} />
                    ),
                    EditScheduleButton: (item) => (
                        <i title="Edit Schedule" className='btn btn-schedule far fa-calendar-edit' onClick={() => {
                            selectCallback(item.Id); 
                            setSection(SECTION_SCHEDULE);}} />
                    ),
                    DeleteButton: (item) => (
                        <i title="Delete" className='btn btn-delete far fa-trash-alt' onClick={() => { (window.confirm('Are you sure you wish to delete this item?')) && deleteSubmit(item.Id) }} />
                    ),
                }}
                />
                <div className='button-group'>
                    {schedulesPage.length === schedules.length ?  <p id="end-results"> ~~~ </p> : <button className='btn-load' onClick={() => setPage(page+1)}><i className='fas fa-chevron-circle-down fa-2x'></i></button>}
                    {page > 1 ?  <button className='btn-load' onClick={() => setPage(page-1)}><i className='fas fa-chevron-circle-up fa-2x'></i></button> : '' }
                </div>
        </div>
    )
}

export default ScheduleList;